export default "__VITE_ASSET__UXbarJDs__"